/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalMCPTaskCancelRequest
 */
export interface InternalMCPTaskCancelRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskCancelRequest
     */
    ownerUserId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskCancelRequest
     */
    ownerClientId: string;
    /**
     * 
     * @type {number}
     * @memberof InternalMCPTaskCancelRequest
     */
    expectedVersion?: number;
}

/**
 * Check if a given object implements the InternalMCPTaskCancelRequest interface.
 */
export function instanceOfInternalMCPTaskCancelRequest(value: object): value is InternalMCPTaskCancelRequest {
    if (!('ownerUserId' in value) || value['ownerUserId'] === undefined) return false;
    if (!('ownerClientId' in value) || value['ownerClientId'] === undefined) return false;
    return true;
}

export function InternalMCPTaskCancelRequestFromJSON(json: any): InternalMCPTaskCancelRequest {
    return InternalMCPTaskCancelRequestFromJSONTyped(json, false);
}

export function InternalMCPTaskCancelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalMCPTaskCancelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ownerUserId': json['owner_user_id'],
        'ownerClientId': json['owner_client_id'],
        'expectedVersion': json['expected_version'] == null ? undefined : json['expected_version'],
    };
}

export function InternalMCPTaskCancelRequestToJSON(json: any): InternalMCPTaskCancelRequest {
    return InternalMCPTaskCancelRequestToJSONTyped(json, false);
}

export function InternalMCPTaskCancelRequestToJSONTyped(value?: InternalMCPTaskCancelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner_user_id': value['ownerUserId'],
        'owner_client_id': value['ownerClientId'],
        'expected_version': value['expectedVersion'],
    };
}

